import React from 'react';
import { NavLink } from 'react-router-dom';
import { useUser } from '../auth/UserContext';

export function Sidebar() {
  const { user } = useUser();
  const role = user?.role || 'none';

  const navItems = [
    { to: '/', label: 'Dashboard', icon: '📊', roles: ['consultant', 'team_lead', 'director', 'admin'] },
    { to: '/team', label: 'Team', icon: '👥', roles: ['team_lead', 'director', 'admin'] },
    { to: '/territory', label: 'Territory', icon: '🗺', roles: ['director', 'admin'] },
    { to: '/company', label: 'Company', icon: '🏢', roles: ['admin'] },
    { to: '/settings', label: 'Settings', icon: '⚙️', roles: ['admin'] },
  ];

  const visibleItems = navItems.filter(item => item.roles.includes(role));

  return (
    <nav className="app-sidebar">
      {/* Logo */}
      <div style={{ padding: '0 20px 20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img
          src="/logo-white.svg"
          alt="Saragossa"
          style={{ height: '22px', opacity: 0.9 }}
        />
      </div>

      <div style={{ padding: '0 20px 16px', fontSize: '11px', fontWeight: 500, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        AI Readiness
      </div>

      {visibleItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
        >
          <span>{item.icon}</span>
          <span>{item.label}</span>
        </NavLink>
      ))}

      {role !== 'none' && (
        <div style={{ marginTop: 'auto', padding: '12px 20px', fontSize: '11px', color: 'var(--text-secondary)', borderTop: '1px solid var(--border-card)' }}>
          <div style={{ textTransform: 'capitalize' }}>{role.replace('_', ' ')}</div>
          {user?.territory && <div>{user.territory}</div>}
          {user?.teamName && <div>{user.teamName}</div>}
        </div>
      )}
    </nav>
  );
}
